<mat-card class="details-sidebar-card">
    <mat-card-header>
        <mat-card-title>{{slot.humanDate}}</mat-card-title>
        <span fxFlex></span>
        <button *ngIf="showCloseButton" mat-icon-button color="primary" (click)="close.emit()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="showRawData" class="raw-data-container">
            <h4>Raw Data for Debugging:</h4>
            <pre>{{ slot | json }}</pre>
        </div>

        <!-- Key Metrics Summary Row -->
        <div class="key-metrics-summary sidebar-metrics">
            <div class="metric-summary-item"  *ngIf="visibleMetrics.sales"
                 [style.border-color]="getBgColorSingle('sales', slot.sales.label)">
                <div class="metric-label" [matTooltip]="tooltipService.getSalesLabelTooltip(slot.sales.label)" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Sales</div>
                <div class="metric-chip"
                     [style.background-color]="getBgColorSingle('sales', slot.sales.label)"
                     [style.color]="getContrastTextColor(getBgColorSingle('sales', slot.sales.label))"
                     [matTooltip]="tooltipService.getSalesLabelTooltip(slot.sales.label)" 
                     matTooltipPosition="above" matTooltipClass="weekly-tooltip"
                >
                    {{ slot.sales.label }}
                </div>
                <div class="metric-value">£{{ slot.sales.value.toFixed(2) }}</div>
            </div>

            <div class="metric-summary-item" *ngIf="visibleMetrics.qpi"
                 [style.border-color]="getBgColorSingle('qpi', slot.qpi.label)">
                <div class="metric-label" [matTooltip]="tooltipService.getQPILabelTooltip(slot.qpi.label)" matTooltipPosition="above" matTooltipClass="weekly-tooltip">QPI</div>
                <div class="metric-chip"
                     [style.background-color]="getBgColorSingle('qpi', slot.qpi.label)"
                     [style.color]="getContrastTextColor(getBgColorSingle('qpi', slot.qpi.label))"
                     [matTooltip]="tooltipService.getQPILabelTooltip(slot.qpi.label)" 
                     matTooltipPosition="above" matTooltipClass="weekly-tooltip"
                >
                    {{ slot.qpi.label }}
                </div>
                <div class="metric-value">{{ formatQpiValue(slot.qpi.value) }}</div>
            </div>

            <div class="metric-summary-item" *ngIf="visibleMetrics.experience"
                 [style.border-color]="getExperienceColor(slot.experience.label)">
                <div class="metric-label" [matTooltip]="tooltipService.getExperienceLabelTooltip(slot.experience.label)" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Experience</div>
                <div class="metric-chip"
                     [style.background-color]="getExperienceColor(slot.experience.label)"
                     [style.color]="getContrastTextColor(getExperienceColor(slot.experience.label))"
                     [matTooltip]="tooltipService.getExperienceLabelTooltip(slot.experience.label)" 
                     matTooltipPosition="above" matTooltipClass="weekly-tooltip"
                >
                    {{ slot.experience.label }}
                </div>
                <div class="metric-value">{{ getDuration(slot) }}</div>
            </div>

            <div class="metric-summary-item" *ngIf="visibleMetrics.staffing"
                 [style.border-color]="getBgColorSingle('staffing', slot.staffing.staffing_class, slot.staffing.staffing_flag)">
                <div class="metric-label" [matTooltip]="tooltipService.getStaffingLabelTooltip(slot.staffing.label)" matTooltipPosition="above" matTooltipClass="weekly-tooltip">Staffing</div>
                <div class="metric-chip"
                     [style.background-color]="getBgColorSingle('staffing', slot.staffing.staffing_class, slot.staffing.staffing_flag)"
                     [style.color]="getContrastTextColor(getBgColorSingle('staffing', slot.staffing.staffing_class, slot.staffing.staffing_flag))"
                     [matTooltip]="tooltipService.getStaffingLabelTooltip(slot.staffing.label)" 
                     matTooltipPosition="above" matTooltipClass="weekly-tooltip"
                >
                    {{ slot.staffing.label }}
                    <ng-container *ngIf="slot.staffing.flag"> *</ng-container>
                </div>
                <div class="metric-value">{{ getCoL(slot) }}%</div>
            </div>
        </div>

        <!-- More Sales Potential Indicator -->
        <div class="more-sales-indicator"
             *ngIf="visibleMetrics.moreSales && slot.qpi.moreSales"
             [ngClass]="'more-sales-' + slot.qpi.moreSales">
            <mat-icon>trending_up</mat-icon>
            <span>More Sales Potential: <strong>{{ formatMoreSalesLabel(slot.qpi.moreSales) }}</strong></span>
        </div>

        <!-- Details Tabs -->
        <mat-tab-group animationDuration="200ms" class="details-tabs sidebar-tabs" headerPosition="above" type="scrollable">
            <mat-tab label="Sales"  *ngIf="visibleMetrics.sales">
                <div class="tab-content">
                    <div class="metric-info">
                        <div class="metric-row">
                            <span class="metric-label">Actual Sales:</span>
                            <span class="metric-value">£{{ slot.sales.value.toFixed(2) }}</span>
                        </div>
                        <!-- <div class="metric-row">
                            <span class="metric-label">Predicted Range:</span>
                            <span class="metric-value">£{{ slot.sales.predicted.low.toFixed(2) }} - £{{ slot.sales.predicted.high.toFixed(2) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">yhat1:</span>
                            <span class="metric-value">
  <ng-container *ngIf="slot.sales.prediction && !isNaN(+slot.sales.prediction); else notAvailable">
    £{{ (+slot.sales.prediction).toFixed(2) }}
  </ng-container>
  <ng-template #notAvailable>N/A</ng-template>
</span>
                        </div> -->
                        <!-- <div class="metric-row">
                            <span class="metric-label">Deviation:</span>
                            <span class="metric-value">{{ getSalesDeviation(slot.sales) }}</span>
                        </div> -->
                        <div class="metric-row">
                            <span class="metric-label">Prediction Deviation:</span>
                            <span class="metric-value">{{ getSalesDeviationPercent(slot.sales) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Average Sales:</span>
                            <span class="metric-value">£{{ slot.sales.sales_mean.toFixed(2) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Week:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.sales.lastWeek != null; else naSalesLW">£{{ slot.sales.lastWeek | number:'1.0-0' }}</ng-container>
                                <ng-template #naSalesLW>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Year:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.sales.lastYear != null; else naSalesLY">£{{ slot.sales.lastYear | number:'1.0-0' }}</ng-container>
                                <ng-template #naSalesLY>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Passerby:</span>
                            <span class="metric-value">{{ slot.sales.passerby }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Average Passerby:</span>
                            <span class="metric-value">{{ slot.stats.passerby_6week_avg.toFixed(0) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Passerby Last Week:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.sales.passerbyLastWeek != null; else naPasserLW">{{ slot.sales.passerbyLastWeek }}</ng-container>
                                <ng-template #naPasserLW>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Passerby Last Year:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.sales.passerbyLastYear != null; else naPasserLY">{{ slot.sales.passerbyLastYear }}</ng-container>
                                <ng-template #naPasserLY>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <div class="weather-widget-compact">
                                <div class="weather-label">Weather:</div>
                                <div class="weather-items">
                                    <div class="weather-item">
                                        <mat-icon class="mini-icon">thermostat</mat-icon>
                                        <span>{{ slot.sales.temperature.toFixed(1) }}°C</span>
                                    </div>
                                    <div class="weather-item">
                                        <mat-icon class="mini-icon">opacity</mat-icon>
                                        <span>{{ slot.sales.rain.toFixed(1) }}mm</span>
                                    </div>
                                    <div class="weather-item">
                                        <mat-icon class="mini-icon">cloud</mat-icon>
                                        <span>{{ slot.sales.clouds_all.toFixed(0) }}%</span>
                                    </div>
                                    <div class="weather-item">
                                        <mat-icon class="mini-icon">air</mat-icon>
                                        <span>{{ slot.sales.wind_speed.toFixed(1) }}m/s</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="metric-row range-indicator">
                            <div class="range-bar">
                                <div class="range-segment" [style.width.%]="100"></div>
                                <div class="range-marker" [style.left.%]="getSalesPercentage(slot.sales)"></div>
                                <div class="range-labels">
                                    <span class="low">£{{ slot.sales.predicted.low.toFixed(0) }}</span>
                                    <span class="high">£{{ slot.sales.predicted.high.toFixed(0) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Queue" *ngIf="visibleMetrics.qpi">
                <div class="tab-content">
                    <div class="metric-info">
                        <div class="metric-row">
                            <span class="metric-label">Efficiency:</span>
                            <span class="metric-value">{{ formatQpiValue(slot.qpi.value) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Week:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.qpi.lastWeek != null; else naQpiLW">{{ formatQpiValue(slot.qpi.lastWeek) }}</ng-container>
                                <ng-template #naQpiLW>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Year:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.qpi.lastYear != null; else naQpiLY">{{ formatQpiValue(slot.qpi.lastYear) }}</ng-container>
                                <ng-template #naQpiLY>N/A</ng-template>
                            </span>
                        </div>
                    </div>

                    <!-- Replace the static efficiency scale with a gradient bar and marker -->
                    <div class="severity-scale sidebar-scale">
                        <h4>Efficiency Scale:</h4>
                        <div class="scale-bar" [style.background]="getQpiGradient()" style="height: 18px; border-radius: 9px; position: relative;">
                            <div class="scale-marker" [style.left.%]="slot.qpi.value * 100" style="position: absolute; top: 0; bottom: 0; width: 2px; background: #222;"></div>
                        </div>
                        <div class="scale-labels-flex">
                            <span *ngFor="let stop of qpiStops">{{ stop.value }}%</span>
                        </div>
                    </div>

                    <div class="component-details">
                        <h4>Component Metrics:</h4>
                        <div class="sidebar-detail-grid">
                            <div class="detail-row">
                                <span class="detail-label">Queue Duration:</span>
                                <span class="detail-value">{{ getDuration(slot) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">Duration at More Sales:</span>
                                <span class="detail-value">{{ getDurationRange(slot, 'estimate') }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">Bottleneck Time:</span>
                                <span class="detail-value">{{ getBottleneck(slot) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">Bottleneck at More Sales:</span>
                                <span class="detail-value">{{ getBottleneckRange(slot) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">Actual Sales:</span>
                                <span class="detail-value">£{{ slot.sales.value.toFixed(2) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="detail-label">Potential Sales:</span>
                                <span class="detail-value">£{{ slot.qpi.ops_estimate_low.toFixed(2) }} - £{{ slot.qpi.ops_estimate_high.toFixed(2) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Experience"  *ngIf="visibleMetrics.experience">
                <div class="tab-content">
                    <div class="metric-info">
                        <div class="metric-row">
                            <span class="metric-label">Service Duration:</span>
                            <span class="metric-value">{{ getDuration(slot) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Week:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.experience.durationsLastWeek != null; else naExpLW">{{ slot.experience.durationsLastWeek | number:'1.0-1' }}s</ng-container>
                                <ng-template #naExpLW>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Year:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.experience.durationsLastYear != null; else naExpLY">{{ slot.experience.durationsLastYear | number:'1.0-1' }}s</ng-container>
                                <ng-template #naExpLY>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Target Duration:</span>
                            <span class="metric-value">{{ slot.experience.duration_target.toFixed(1)}}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Duration Deviation:</span>
                            <span class="metric-value">{{ slot.experience.duration_deviation.toFixed(1)}}%</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Expected Range:</span>
                            <span class="metric-value">{{ getDurationRange(slot) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Classification:</span>
                            <span class="metric-value" [style.color]="getExperienceColor(slot.experience.label)">
                                {{ slot.experience.label }}
                            </span>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Staffing"  *ngIf="visibleMetrics.staffing">
                <div class="tab-content">
                    <div class="metric-info">
                        <div class="metric-row">
                            <span class="metric-label">Labor Cost:</span>
                            <span class="metric-value">£{{ getLaborCost(slot) }}</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Cost of Labor:</span>
                            <span class="metric-value">{{ getCoL(slot) }}%</span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Week:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.staffing.colLastWeek != null; else naColLW">{{ (slot.staffing.colLastWeek * 100) | number:'1.0-1' }}%</ng-container>
                                <ng-template #naColLW>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Last Year:</span>
                            <span class="metric-value">
                                <ng-container *ngIf="slot.staffing.colLastYear != null; else naColLY">{{ (slot.staffing.colLastYear * 100) | number:'1.0-1' }}%</ng-container>
                                <ng-template #naColLY>N/A</ng-template>
                            </span>
                        </div>
                        <div class="metric-row">
                            <span class="metric-label">Target Range:</span>
                            <span class="metric-value">{{ getCoLRange(slot) }}</span>
                        </div>
                    </div>

                    <div *ngIf="slot.staffing.flag === 'unlikely'" class="staffing-flag">
                        <mat-icon class="warning-icon">warning</mat-icon>
                        <div class="flag-text">
                            The "unlikely" flag indicates conflicting metrics: {{ slot.staffing.label }}
                            with {{ slot.qpi.label }} QPI.
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
